// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout_root__1CW3Y","content":"Layout_content__2Aeoj"};